// extracted by mini-css-extract-plugin
export default {"fixed":"Erreur404_fixed__xDPib","container":"Erreur404_container__t3As-"};